import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router';
import type { TUseSyncManagerApplicationsUrlStateParams } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/types.ts';
import { buildManagerApplicationsUrlSearch } from '~/modules/covenants/CovenantsDataForm/CovenantsFormByManager/utils/managerApplicationsUrlUtils.ts';

export const useSyncManagerApplicationsUrlState = ({
  page,
  rowsPerPage,
  submittedSearchQuery,
  startDate,
  endDate,
  sortKey,
  sortDirection,
  status,
  assignee,
  segmentIds,
}: TUseSyncManagerApplicationsUrlStateParams) => {
  const location = useLocation();
  const navigate = useNavigate();
  const nextSearch = useMemo(
    () =>
      buildManagerApplicationsUrlSearch({
        currentSearch: location.search,
        page,
        rowsPerPage,
        submittedSearchQuery,
        startDate,
        endDate,
        sortKey,
        sortDirection,
        status,
        assignee,
        segmentIds,
      }),
    [
      assignee,
      endDate,
      location.search,
      page,
      rowsPerPage,
      sortDirection,
      sortKey,
      startDate,
      status,
      submittedSearchQuery,
      segmentIds,
    ]
  );

  useEffect(() => {
    const currentSearch = location.search.startsWith('?')
      ? location.search.slice(1)
      : location.search;

    if (nextSearch === currentSearch) {
      return;
    }

    navigate(
      {
        pathname: location.pathname,
        search: nextSearch ? `?${nextSearch}` : '',
      },
      { replace: true }
    );
  }, [location.pathname, location.search, navigate, nextSearch]);

  return nextSearch ? `?${nextSearch}` : '';
};
